import { IonContent, IonPage } from '@ionic/react';
import React, { useEffect } from 'react';
import LayoutGap from '../../layouts/LayoutGap';

import { RouteComponentProps } from 'react-router';
import Toolbar from '../../layouts/Toolbar';

import { useDispatch } from 'react-redux';
import LoadingContainer from '../../components/loading/LoadingContainer';
import { PageAction } from '../../redux/actions/Home';
import { useAppSelector } from '../../redux/hooks';
import Description from '../campaigns/Description';
import './Single.css';

interface Props extends RouteComponentProps<{
    page: string
}> { }

const SinglePage: React.FC<Props> = ({ match }) => {
    const dispatch = useDispatch();
    const { loading, page } = useAppSelector(state => state.pageGet)

    useEffect(() => {
        dispatch(PageAction(match.params.page));
    }, [dispatch])

    return <LoadingContainer loading={loading}>
        <IonPage className="campaign-detail">
            <Toolbar title={page.title!} hasBackButton />

            <LayoutGap />

            <IonContent className="main-content">
                <Description content={page.content!} />
            </IonContent>
        </IonPage>
    </LoadingContainer>
}

export default SinglePage